import * as isoly from "isoly";
export function getLanguage(element) {
    const result = element.lang;
    const parent = element.parentElement;
    return result && result != "unknown" ? convert(result) : parent ? getLanguage(parent) : convert(navigator.language);
}
function convert(language) {
    if (language && language != "unknown" && language.length >= 2)
        language = language.substring(0, 2);
    return isoly.Language.is(language) ? language : undefined;
}
//# sourceMappingURL=getLanguage.js.map